import React, { useState,useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AuthPages.css';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  // ✅ S3 base host from .env (React env must start with REACT_APP_)
  // Example:
  // REACT_APP_S3_IMAGES_BASE=https://bucket-datastore-mark1.s3.ap-south-1.amazonaws.com/Images
  const ICONS_BASE = (process.env.REACT_APP_S3_ICONS_BASE || "").replace(/\/$/, "");
  const IMAGES_BASE = (process.env.REACT_APP_S3_IMAGES_BASE || "").replace(/\/$/, "");


  // ✅ helper to build icons url
  const img = (fileName) => {
    const url = `${IMAGES_BASE}/${fileName}`;
    console.log("Generated URL:", url); // Debug log
    return url;
  };

  const ico = (fileName) => {
    const url = `${ICONS_BASE}/${fileName}`;
    console.log("Generated URL:", url); // Debug log
    return url;
  };

  // ✅ Debug: Log the base URL on component mount
  useEffect(() => {
    
    console.log("IMAGE_BASE:", ICONS_BASE);
    console.log("Sample URL:", ico("logo-header.png"));
  }, []);

  
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.email, formData.password);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.message || 'Login failed. Please try again.');
    }
    
    setLoading(false);
  };

  return (
    <div className="login-wrapper">
      {/* LEFT PANEL */}
      <div className="left-panel">
        <div className="logo-circle">
          <img src={ico("login-logo.svg")} alt="Logo" />
        </div>

        <h2>Log in to your Account</h2>
        <p className="subtext">Welcome Back! Select Method to log in</p>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <label htmlFor="email">Email</label>
          <div className="input-field">
            <img src={ico("mail.svg")} className="input-icon" alt="" />
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
            />
          </div>

          <label htmlFor="password">Password</label>
          <div className="input-field">
            <img src={ico("lock.svg")} className="input-icon" alt="" />
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter password"
              required
            />
          </div>

          <button 
            type="submit" 
            className="btn-login"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Log in'}
          </button>
        </form>

        <p className="create-account">
          Don't have an account?
          <Link to="/signup"> Create an account</Link>
        </p>
        <Link to="/" className="back-home">← Back to Home</Link>
      </div>

      {/* RIGHT PANEL */}
      <div className="right-panel">
        <img src={img("bg-graphic.png")} className="bg-graphic" alt="" />
        <img src={img("login-illustration.png")} className="main-image" alt="" />

        <img src={ico("Instagram.png")} className="floating-icon insta" alt="" />
        <img src={ico("facebook.png")} className="floating-icon fb" alt="" />
        <img src={ico("linkedin.png")} className="floating-icon li" alt="" />

        <p className="connect-text">Connect with Any Socials</p>
      </div>
    </div>
  );
};

export default LoginPage;
